module.exports = __webpack_public_path__ + "img/c4.854b0154.jpg";